import { create } from '@thoughtspot/logger';
import { convertPointValToNameValPair, validateShowToolTipEventPayloadObject, } from './util';
const logger = create('tooltip-events');
const validateShowToolTipEventPayload = (eventData, columns) => {
    const payload = eventData.payload;
    try {
        validateShowToolTipEventPayloadObject(payload, columns);
    }
    catch (err) {
        logger.warn(err);
        return {
            isValid: false,
            errors: [err.toString()],
        };
    }
    return {
        isValid: true,
    };
};
const getShowToolTipEventProcessor = (props) => {
    const { chartModel, showToolTip, iFrameWindow } = props;
    const chartColumns = chartModel.columns.map(col => col.column);
    return {
        validateEventPayload: (eventData) => {
            return validateShowToolTipEventPayload(eventData, chartColumns);
        },
        executeEvent: (eventData) => {
            const payload = eventData.payload;
            const { point, customTooltipContent, event: inputEvent } = payload;
            const domRect = iFrameWindow.current.getBoundingClientRect();
            const eventObj = {
                ...inputEvent,
                clientX: inputEvent.clientX + domRect.x,
                clientY: inputEvent.clientY + domRect.y,
            };
            const pointDetails = convertPointValToNameValPair(point, chartColumns);
            showToolTip(eventObj, customTooltipContent, iFrameWindow.current, pointDetails);
            return Promise.resolve();
        },
    };
};
const getHideToolTipEventProcessor = (props) => {
    const { hideToolTip } = props;
    return {
        validateEventPayload: (eventData) => {
            return {
                isValid: true,
            };
        },
        executeEvent: (eventData) => {
            hideToolTip();
            return Promise.resolve();
        },
    };
};
const testHooks = {
    validateShowToolTipEventPayload,
};
export { getShowToolTipEventProcessor, getHideToolTipEventProcessor, testHooks, };
//# sourceMappingURL=index.js.map